import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputField from './InputField';
import stringUtils from "../../../utils/string";


class ServiceRequestField extends Component {
    _renderLabel () {
        const { srNumber, siteName, siteCity } = this.props.entry.serviceRequest;

        return (srNumber)
            ? `${srNumber} - ${siteName}, ${siteCity}`
            : '';
    }

    _renderValue () {
        const { serviceRequestId, serviceRequest } = this.props.entry;

        return (
            <div>
                <div>SR #<strong>{serviceRequestId}</strong></div>
                <div>{stringUtils.truncate(serviceRequest.siteName, 35)}</div>
                <div>
                    <small>{stringUtils.truncate(
                        `${serviceRequest.siteCity} ${serviceRequest.siteRegion}`,
                        35
                    )}</small>
                </div>
            </div>
        );
    }

    render () {
        return (
            <InputField
                colClass={this.props.colClass}
                hasError={this.props.hasError}
                hidden={this.props.fieldPermission === 'hidden'}
                onClear={() => this.props.onClear()}
                onClick={() => this.props.onClick()}
                onRenderValue={() => this._renderValue()}
                placeholder="Select your Service Request"
                required={this.props.fieldPermission === 'required'}
                title="Service Request"
                type="button"
                value={this._renderLabel()}
            />
        );
    }
}


ServiceRequestField.propTypes = {
    colClass: PropTypes.string.isRequired,
    entry: PropTypes.object.isRequired,
    fieldPermission: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    onClear: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};


export default ServiceRequestField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/ServiceRequestField.jsx